module.exports = __webpack_public_path__ + "static/media/confirm.6afe69cf.svg";